import React from 'react';

const Terms = () => {
  return (
    <div style={{paddingTop: '100px'}}>
      <section className="section">
        <div className="container">
          <h1 className="section-title">Terms of Service</h1>
          
          <div style={{maxWidth: '800px', margin: '0 auto', lineHeight: '1.8'}}>
            <p style={{marginBottom: '2rem', fontStyle: 'italic'}}>
              <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Agreement to Terms</h2>
            <p style={{marginBottom: '2rem'}}>
              These Terms of Service ("Terms") constitute a legally binding agreement between you and MEES HOLDINGS INC 
              ("Company," "we," "our," or "us") regarding your use of our SMS marketing services and website at 
              https://meesmarketing.com/. By accessing or using our services, you agree to be bound by these Terms.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Company Information</h2>
            <div style={{background: '#f8fafc', padding: '1.5rem', borderRadius: '10px', marginBottom: '2rem'}}>
              <p><strong>Legal Name:</strong> MEES HOLDINGS INC</p>
              <p><strong>Address:</strong> 2022 E 9TH ST, BROOKLYN, NY 11223</p>
              <p><strong>EIN:</strong> 93-4196857</p>
              <p><strong>Website:</strong> https://meesmarketing.com/</p>
            </div>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Services Description</h2>
            <p style={{marginBottom: '1rem'}}>MEES HOLDINGS INC is an authorized reseller providing SMS marketing services including:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Reselling Application-to-Person (A2P) SMS messaging services</li>
              <li>Campaign management and optimization consulting</li>
              <li>Compliance consulting and guidance</li>
              <li>Analytics and reporting support</li>
              <li>Platform integration assistance</li>
              <li>Customer support and account management</li>
            </ul>
            <p style={{marginBottom: '2rem', fontStyle: 'italic', color: '#6b7280'}}>
              Note: SMS messaging services are provided through our partnerships with established SMS service providers. 
              We act as an authorized reseller and consultant.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Acceptable Use Policy</h2>
            <p style={{marginBottom: '1rem'}}>You agree to use our services only for lawful purposes and in accordance with these Terms. You may not:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Send messages without proper consent from recipients</li>
              <li>Transmit spam, unsolicited, or bulk messages</li>
              <li>Use our services for illegal, fraudulent, or harmful activities</li>
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe on intellectual property rights</li>
              <li>Transmit malicious code or harmful content</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with the proper functioning of our services</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Compliance Requirements</h2>
            <p style={{marginBottom: '1rem'}}>You acknowledge and agree that:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>You are responsible for obtaining proper consent before sending messages</li>
              <li>All messages must comply with TCPA, CAN-SPAM, and other applicable regulations</li>
              <li>You must provide clear opt-out mechanisms in all marketing messages</li>
              <li>You will maintain records of consent and opt-out requests</li>
              <li>You will honor opt-out requests promptly</li>
              <li>Message content must be truthful and non-deceptive</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Account Registration and Security</h2>
            <p style={{marginBottom: '1rem'}}>To use our services, you must:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Provide accurate and complete registration information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Notify us immediately of any unauthorized access</li>
              <li>Accept responsibility for all activities under your account</li>
              <li>Keep your account information current and accurate</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Payment Terms</h2>
            <p style={{marginBottom: '1rem'}}>Payment terms include:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>Fees are due in advance according to your selected plan</li>
              <li>All fees are non-refundable unless otherwise specified</li>
              <li>We reserve the right to modify pricing with 30 days notice</li>
              <li>Accounts may be suspended for non-payment</li>
              <li>You are responsible for all applicable taxes</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Service Availability</h2>
            <p style={{marginBottom: '2rem'}}>
              While we work with reliable SMS service providers, we do not guarantee uninterrupted service availability. 
              Service availability depends on our partner providers and their infrastructure. Maintenance, updates, or 
              technical issues may temporarily affect service availability. We are not liable for downtime or service 
              interruptions caused by our partner providers or third-party services.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Intellectual Property</h2>
            <p style={{marginBottom: '2rem'}}>
              All content, features, and functionality of our services are owned by MEES HOLDINGS INC and are 
              protected by copyright, trademark, and other intellectual property laws. You may not reproduce, 
              distribute, or create derivative works without our express written permission.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Data and Privacy</h2>
            <p style={{marginBottom: '2rem'}}>
              Your privacy is important to us. Our collection and use of personal information is governed by our 
              Privacy Policy, which is incorporated into these Terms by reference. By using our services, you 
              consent to the collection and use of information as described in our Privacy Policy.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Limitation of Liability</h2>
            <p style={{marginBottom: '2rem'}}>
              To the maximum extent permitted by law, MEES HOLDINGS INC shall not be liable for any indirect, 
              incidental, special, consequential, or punitive damages, including but not limited to loss of profits, 
              data, or business opportunities, arising from your use of our services.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Indemnification</h2>
            <p style={{marginBottom: '2rem'}}>
              You agree to indemnify and hold harmless MEES HOLDINGS INC from any claims, damages, losses, or 
              expenses arising from your use of our services, violation of these Terms, or infringement of any 
              third-party rights.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Termination</h2>
            <p style={{marginBottom: '1rem'}}>We may terminate or suspend your account and access to our services:</p>
            <ul style={{marginBottom: '2rem', paddingLeft: '2rem'}}>
              <li>For violation of these Terms</li>
              <li>For non-payment of fees</li>
              <li>For illegal or harmful activities</li>
              <li>At our sole discretion with or without cause</li>
            </ul>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Governing Law</h2>
            <p style={{marginBottom: '2rem'}}>
              These Terms are governed by the laws of the State of New York, without regard to conflict of law 
              principles. Any disputes arising from these Terms or your use of our services shall be resolved 
              in the courts of New York.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Changes to Terms</h2>
            <p style={{marginBottom: '2rem'}}>
              We reserve the right to modify these Terms at any time. We will notify you of material changes by 
              posting the updated Terms on our website and updating the "Last Updated" date. Your continued use 
              of our services after such changes constitutes acceptance of the new Terms.
            </p>

            <h2 style={{color: '#2563eb', marginBottom: '1rem'}}>Contact Information</h2>
            <div style={{background: '#f8fafc', padding: '2rem', borderRadius: '10px'}}>
              <p>If you have questions about these Terms, please contact us:</p>
              <p><strong>MEES HOLDINGS INC</strong></p>
              <p>2022 E 9TH ST<br />BROOKLYN, NY 11223<br />United States</p>
              <p>Email: legal@meesmarketing.com</p>
              <p>Support: support@meesmarketing.com</p>
              <p style={{marginTop: '1rem', fontSize: '0.9rem', color: '#6b7280'}}>
                For legal inquiries, please email us or use our contact form.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;